import { getErrorMessage } from "../../../../helper/getResponseMessage";
import { showError, showSuccess } from "../../../../util/ShowStatus";
import axios from "../../../../util/axiosconfig";
// import { ROLE_NAMES } from "../../../../util/constants";
import { ROLES } from "../../../../util/roleNameConstants";

export const fetchUsersList = async (
  setUsersList: any,
  toast: any,
  setStaffMembers: any,
  setFormValues: any,
  formValues: any,
  type: string = "add"
) => {
  try {
    const response = await axios.get(
      `admin/user/list?page=-1&roleName=${encodeURIComponent(
        ROLES.HANDS_USER
      )}`
    );
    setUsersList(response.data.result);
    if (!localStorage.roleName.includes(ROLES.HANDS_ADMIN)) {
      const loggedInUser = response.data.result.find(
        (user: any) =>
          user.userEmail.toString() === localStorage.userEmail.toString()
      );
      setStaffMembers([loggedInUser]);
      setFormValues((prev: any) => ({
        ...prev,
        amelioStaff: [
          {
            userID: loggedInUser.userID,
            displayName: loggedInUser.displayName,
          },
        ],
      }));
    }
    if (type === "edit") {
      const staffMember = response.data.result.filter(
        (user: any) =>
          Array.isArray(formValues.amelioStaff) &&
          formValues.amelioStaff.some(
            (staff: any) => staff.userID === user.userID
          )
      );
      if (staffMember && staffMember.length > 0) {
        setStaffMembers(staffMember);
      }
    }
  } catch (err) {
    const error = getErrorMessage(err);
    showError(error, toast);
  }
};

export const fetchAmelioID = async (setFormValues: any, toast: any) => {
  try {
    const response = await axios.get(
      "health-and-safety/get-amelio-id?formKey=belfast"
    );
    // setAmelioID(response.data.result);
    setFormValues((prev: any) => ({
      ...prev,
      amelioID: response.data.result,
    }));
  } catch (err) {
    const error = getErrorMessage(err);
    showError(error, toast);
  }
};

export const fetchVehiclesList = async (
  setVehiclesList: any,
  formValues: any,
  setVehicle: any,
  toast: any,
  type: string = "add"
) => {
  try {
    const response = await axios.get("tl-admin/vehicle/all?page=-1");
    if (Array.isArray(response.data.result)) {
      const vehicles = response.data.result;
      const noVehicleIndex = vehicles.findIndex(
        (v: any) => v.registration_no === "No Vehicle"
      );
      if (noVehicleIndex > -1) {
        const [noVehicle] = vehicles.splice(noVehicleIndex, 1);
        vehicles.unshift(noVehicle);
      }
      if (type === "edit") {
        setVehicle(
          vehicles.find(
            (v: any) => v.registration_no === formValues.vehicleRegistration
          )
        );
      }
      // Set the vehicles list in state
      setVehiclesList(vehicles);
      return;
    }
    setVehiclesList(response.data.result);
  } catch (err) {
    const error = getErrorMessage(err);
    showError(error, toast);
  }
};

export const fetchAllJobSheetBelfastForms = async (
  setJobSheetBelfastForms: any,
  setJobSheetBelfastFormsLoading: any,
  filters: any,
  toast: any
) => {
  try {
    const params: any = {};
    if (filters && filters.startDate && filters.endDate) {
      // Convert to UTC ISO string
      params.startDate = filters.startDate;
      params.endDate = filters.endDate;
    }
    setJobSheetBelfastFormsLoading(true);
    const response = await axios.get(
      "health-and-safety/job-sheet-belfast-form-all",
      {
        params,
      }
    );
    setJobSheetBelfastForms(response.data.result);
    setJobSheetBelfastFormsLoading(false);
  } catch (err) {
    const error = getErrorMessage(err);
    setJobSheetBelfastFormsLoading(false);
    showError(error, toast);
  }
};

export const getFormByFormID = async (
  setFormData: any,
  setFormDataLoading: any,
  formIDParam: number,
  navigate: any,
  toast: any
) => {
  try {
    setFormDataLoading(true);
    const response = await axios.get(
      `health-and-safety/job-sheet-belfast-form-by-id?formID=${formIDParam}`
    );
    if (response.data.result.length === 0) {
      showError("Form not found", toast);
      setFormDataLoading(false);
      navigate("/layout/health-and-safety/jobsheet-belfast");
      return;
    }
    setFormData(response.data.result);
    setFormDataLoading(false);
  } catch (err) {
    const error = getErrorMessage(err);
    setFormDataLoading(false);
    showError(error, toast);
  }
};
